import { Fragment } from 'react'
import { highlightMatches } from '../../utils/searchQuery'

/**
 * Renderiza texto con highlights de los términos de búsqueda.
 * Soporta truncado opcional.
 */
export function HighlightedText({ text, query, maxLength, className }: {
  text: string
  query: string
  maxLength?: number
  className?: string
}) {
  if (!text) return null

  let display = text
  let wasTruncated = false
  if (maxLength && text.length > maxLength) {
    display = text.slice(0, maxLength)
    wasTruncated = true
  }

  const parts = highlightMatches(display, query)

  return (
    <span className={className}>
      {parts.map((part, idx) => {
        if (typeof part === 'string') {
          return <Fragment key={idx}>{part}</Fragment>
        }
        return (
          <mark
            key={idx}
            className="bg-yellow-200 dark:bg-yellow-500/30 text-gray-900 dark:text-gray-100 rounded px-0.5"
          >
            {part.match}
          </mark>
        )
      })}
      {wasTruncated && <span className="text-gray-400">…</span>}
    </span>
  )
}
